export enum CountryEnum{
    brasil1=13,
    brasil2=28,
    brasil3=47,
    colombia1=1,
    colombia2=16,
    colombia3=35,
}
